const TRANSLATIONS_NAMESPACE = "form-viewer";
export {
  TRANSLATIONS_NAMESPACE
};
//# sourceMappingURL=translations.js.map
